
import { Injectable, NgModule } from '@angular/core';
import { BrowserModule, HammerGestureConfig, HammerModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { CommonModule } from "@angular/common";
// MODULES IONIC/CORDOVA
// import { StatusBar } from '@ionic-native/status-bar/ngx';

import { WebView } from '@ionic-native/ionic-webview/ngx';
import { IOSFilePicker } from '@ionic-native/file-picker/ngx';
import { ImagePicker, ImagePickerOptions } from '@ionic-native/image-picker/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { Media } from '@ionic-native/media/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { MediaCapture, MediaFile, CaptureError, CaptureImageOptions } from '@ionic-native/media-capture/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppAvailability } from '@awesome-cordova-plugins/app-availability/ngx';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';

import { HTTP } from '@ionic-native/http/ngx';
import { FCM } from '@ionic-native/fcm/ngx';
import { AppLauncher } from '@ionic-native/app-launcher/ngx';
import { Network } from '@ionic-native/network/ngx';


import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
   declarations: [
      AppComponent,
   ],
   entryComponents: [],
   imports: [
      BrowserModule,
      IonicModule.forRoot({
         swipeBackEnabled: false,
         mode: 'ios'
      }),
      AppRoutingModule,
      HttpClientModule,
      BrowserAnimationsModule,
      MatInputModule,
      MatFormFieldModule,
      MatSelectModule,
      MatCheckboxModule,
      NgbModule,
      HammerModule,
      CommonModule,

   ],
   providers: [
      SplashScreen,
      HTTP,
      File,
      FileTransfer,
      Camera,
      Media,
      MediaCapture,
      IOSFilePicker,
      ImagePicker,
      FileChooser,
      ScreenOrientation,
      FileOpener,
      FilePath,
      WebView,
      HTTP,
      Network,
      FCM,
      AppLauncher,
      AppAvailability,
      BackgroundMode,
    
      {
         provide: RouteReuseStrategy,
         useClass: IonicRouteStrategy
      },

      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    

   ],
   bootstrap: [AppComponent]
})

export class AppModule {}
